/**
 * Cuándo un hueco de observación se avisa en el portal (spec 035 · FR-001).
 *
 * Un recreate de la API deja ~1 min. Avisar eso enseña a ignorar el aviso.
 * Cinco minutos: un reinicio ya pasó; un sondeo parado de verdad, no.
 */
export const MINUTOS_HUECO_QUE_AVISA = 5

export function seAvisaHueco(minutos: number | null | undefined): boolean {
    return typeof minutos === 'number' && Number.isFinite(minutos) && minutos >= MINUTOS_HUECO_QUE_AVISA
}
